import { Fragment } from 'react'
import { useSearchParams } from 'react-router'

import { Pinline } from '@/components/Pinline'

import { useFilterDescriptions } from './hooks/useFilterDescriptions'
import { useShipmentFilterListContext } from './ShipmentFilterListProvider'

type FilterDescriptionProps = {
  isCustomFilter: boolean
}

export const FilterDescription = ({
  isCustomFilter,
}: FilterDescriptionProps) => {
  const filterConfig = useShipmentFilterListContext(s => s.filterConfig)
  const [searchParams] = useSearchParams()
  const selectedFilters = useFilterDescriptions(filterConfig, searchParams)
  if (!isCustomFilter) return null

  return (
    <>
      <Pinline className="my-3" />
      <p className="mb-3">
        {selectedFilters.map((filter, index) => (
          <Fragment key={filter}>
            {index > 0 && <br />}
            <span>{filter}</span>
          </Fragment>
        ))}
      </p>
    </>
  )
}
